/* eslint-disable react/prop-types */
import {
  Typography, Card, List, ListItem,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CourseObjectivesAndRessources = ({ courseInfos }) => {
  const { t } = useTranslation();
  return (
    <Card style={{ padding: '15px' }}>
      <Typography variant="subtitle2">{t('courseInformations.courseObjectives.objectives', 'Objectifs de la formation:')}</Typography>
      <List>
        {courseInfos.objectives.map((objective) => (
          <ListItem>
            <Typography variant="body2">{objective.name}</Typography>
          </ListItem>
        ))}
      </List>
      <Typography variant="subtitle2">{t('courseInformations.courseObjectives.resources', 'Ressources pédagogiques utilisées:')}</Typography>
      {courseInfos.resources.length > 0
        ? (
          <List>
            {courseInfos.resources.map((resource) => (
              <>
                {resource.suggested
            && (
            <ListItem>
              <Typography variant="body2">{resource.name}</Typography>
            </ListItem>
            )}
              </>
            ))}
          </List>
        )
        : (
          <div style={{ marginTop: '15px' }}>
            <Typography variant="body2">{t('courseInformations.courseObjectives.toValidate', 'A valider avec le formateur lors des premières séances.')}</Typography>
            <Typography variant="body2">
              {t('courseInformations.courseObjectives.suports', 'Utilisation de supports divers et authentiques (presse, journaux économiques et culturels ainsi que podcasts, sites internet...)')}
            </Typography>
          </div>
        )}
    </Card>
  );
};

export default CourseObjectivesAndRessources;
